export const BI_VAL_OTHER = 'EGYEB';

export const BILLING_METHOD_PERSONAL = 'billing_private_person';
export const BILLING_METHOD_COMPANY = 'billing_company';
export const BILLING_METHOD_DELIVERY = 'billing_same_as_delivery';
